// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
// This File should be used when site is live

export const environment = {
  production: true,
  versionCheckURL: 'https://www.jamestowndistributors.com/version.json',
  // Domain URL
  domainURL: 'https://www.jamestowndistributors.com',
  // Search Spring Credentials Start
  searchSpringURL: 'https://k4wrjy.a.searchspring.io/api',
  searchSpringIntelliSuggestURL: 'https://k4wrjy.a.searchspring.io/api/suggest/query',
  searchSpringSiteId: 'k4wrjy',
  // Search Spring Credentials End

  // Server Credentials Start
  UserID: '4Ais-WL+WV3,4_wFPv8Vc#SQ7qzoN(tt',
  SiteID: 'F(qO0cINsp%0uD_.SDROmpijb0Ca%O@@',
  baseURL: 'https://api.jamestowndistributors.com/v1', // AWS production platform
  // Server Credentials End
  // Cognito Credentials Start
  cognito: {
    userPoolId: 'us-east-1_muMYwFmmg', // AWS Pool ID
    region: 'us-east-1', // AWS Region
    clientId: '5rrlorlb4bj4net7qjlacernib' // AWS Client ID
  },
  // Cognito Credentials End

  // Google Mesurement Id
  gaMasurementId: 'G-9CFXLBHED5',
  // Google Mesurement Id

  // Google Site Id
  googleSiteId: '6Lcn1nscAAAAAHDuWvUVGbFCCw2AJW5G_7zZGNmz',
  // Google Site Id

  // Google Site Id
  googleApiId: 'AIzaSyCoobixwdQkeglC6-xK4ucYY6Q4og6Q46o',
  // Google Site Id

  // Paypal Credentials
  paypal: {
    payPalAccessTokenUrl: 'https://api.sandbox.paypal.com/v1/oauth2/token',
    paypalAPILoginID: '44AP9hu7',
    paypalTransactionKey: '6z8B78h6sVFS2wq9',
    payPalClientID: 'AV4AWxbmniuTlcFt_XbsujMW-KHJZKSyrLhe8odZA85zDj_TdIqkhMxIaEnlKqQjBWCkGJR9IHYdDUUe',
    payPalSecret: 'EIJ4xbWWZ6jXwkr0bhzHzNNVFSZEt5HOdMqUVxJguk2ISoaMK6axpo77uZBykYkZCM2RCE1AjzXbV99A',
    payPalSuccessUrl: 'https://my.server.com/success.html',
    payPalCancelUrl: 'https://my.server.com/cancel.html',
    payPalAPIUrlTest: 'https://api.sandbox.paypal.com',
    payPalAPIUrl: 'https://api.sandbox.paypal.com'
  },
  // Paypal Credentials

  // Apple Pay Credentials
  applePay: {
    //merchantIdentifier: 'FC8A545071C274A7BB95E9109D42D99E61510B11CF614E543A5874643FD38936',
    merchantIdentifier: 'merchant.com.jamestowndistributors.www',
    applePayOpaqueDataDescriptor: 'COMMON.APPLE.INAPP.PAYMENT',
    merchantCapabilities: {
      supportsCredit: 'supportsCredit',
      supportsDebit: 'supportsDebit',
      supports3DS: 'supports3DS'
    },
    supportedNetworks: {
      masterCard: 'masterCard',
      discover: 'discover',
      amex: 'amex',
      visa: 'visa'
    },
    supportedMethods: 'https://apple.com/apple-pay',
    displayName: 'Jamestown Distributors, LLC',
    initiative: 'web',
    initiativeContext: 'www.jamestowndistributors.com'
  },
  // Apple Pay Credentials
  // Payment gateway

  // pro-sitemap Credentials Start
  proSitemapApiKey: 'ps_gzvuXeX.KI2n7ddRy6EKWAJUf8hFHVR1KsBq0EPYa1vlg3W5UCwU6T',
  proSitemapSiteId: '4058640',
  proSitemapApiUrl: 'https://pro-sitemaps.com/api/',
  // pro-sitemap Credentials End

  // Bloomreach Credentials Start
  bloomreachApiUrl: 'https://us3-api.eng.bloomreach.com',
  bloomreachApiToken: '4ccb803a-5681-11ef-b587-a2e44f584de7',
  // Bloomreach Credentials End
};
